export default "/images/IvoMikić.jpg?f3a0702d968fc10b695fc19073b0ab27";